import React, {useState, useEffect} from "react";
import {
    FormGroup,
    Checkbox,
    Glyphicon
} from "react-bootstrap";
import {
    patchUser,
    getUserMe,
} from "../utils/bedrockAPI";
import { getUser, getToken, mobileCheck, setUserSession } from "../utils/Common";
import { getFCMToken } from "../Firebase";
import Denied from "../images/permissions-denied.png";

export default function MasterNotifications({setAppNotificationsParent, ...props}) {
    const [permissionState, setPermissionState] = useState();
    const [appNotifications, setAppNotifications] = useState(false);
    const [desktopNotifications, setDesktopNotifications] = useState(false);
    const [settings, setSettings] = useState(null);
    const [userId, setUserId] = useState(null);
    const [showUnblock,setShowUnblock] = useState(false);
    const [pwmApp, setPwmApp] = useState(false);
    const [showDesktopFromMobile, setShowDesktopFromMobile] = useState(false);
    const [showMobileFromDesktop, setShowMobileFromDesktop] = useState(false);
    const [user, setUser] = useState(null);

    useEffect(() => {
        let isMounted = true;
        navigator.permissions
        .query({ name: 'notifications' })
        .then(permission => {if(isMounted) setPermissionState(permission.state)});

        if (window.matchMedia('(display-mode: standalone)').matches) {
            setPwmApp(true);
        }

        async function fetchUser() {
            const uu = await getUserMe();
            if(isMounted) {
                setUserSession(getToken(),uu);
                setUser(uu);
            }
        }

        fetchUser();
        return () => { isMounted = false; };
    },[]);

    useEffect(() => {
        let isMounted = true;
        if(user) {
            let updateUser = false;
            if(user.userId!=null) setUserId(user.userId);
            if(user.settings!=null) {
                if(user.settings.powerSummaryNotifications == null) {
                    user.settings.powerSummaryNotifications = false;
                    updateUser = true;
                }
                if(user.settings.email == null) {
                    user.settings.email = true;
                    updateUser = true;
                }
                if(isMounted)
                    setSettings(user.settings);
            } else {
                const tempSettings = {powerSummaryNotifications:false};
                user.settings = tempSettings;
                if(isMounted) {
                    setSettings(tempSettings);
                    updateUser = true;
                }
            }
            if(updateUser) {
                const newUser = {userId:user.userId,settings:user.settings};
                patchUser(user.userId,newUser)
            }
            if(user.settings && user.settings.appEnabled) {
                if(Notification.permission==="granted") {
                    if(isMounted) {
                        setAppNotifications(true);
                        setAppNotificationsParent(true);
                    }
                }
            } else if(user.settings && user.settings.desktopEnabled) {
                if(Notification.permission==="granted") {
                    if(isMounted)
                        setDesktopNotifications(true);
                }
            }
        }
        return () => { isMounted = false; };
    },[user]);

    useEffect(() => {
        let isMounted = true;
        if(permissionState==="granted") {
            const u = getUser();
            if(u.settings) {
                if(u.settings.appEnabled && mobileCheck()) {
                    if(isMounted) {
                        setAppNotifications(true);
                        setAppNotificationsParent(true);
                        setShowUnblock(false);
                    }
                }
                if(isMounted && u.settings.desktopEnabled && !mobileCheck()) {
                    if(isMounted) {
                        setDesktopNotifications(true);
                        setShowUnblock(false);
                    }
                }
            }
        } else if (permissionState==="denied") {
            if(mobileCheck()) {
                if(isMounted) {
                    setAppNotifications(false);
                    setAppNotificationsParent(false);
                    setShowUnblock(true);
                }
            } else {
                if(isMounted) {
                    setDesktopNotifications(false);
                    setShowUnblock(true);
                }
            }
        }
        return () => { isMounted = false; };
    },[permissionState]);

    async function handleEmailOverride() {
        var newSettings = JSON.parse(JSON.stringify(settings));
        newSettings.email = !newSettings.email;
        setSettings(newSettings);
        const newUser = {userId:userId,settings:newSettings};
        await patchUser(userId,newUser);
    }

    async function handleDesktopOverride() {
        let u = getUser();
        if(!mobileCheck() && Notification.permission==="denied") {
            setShowUnblock(true);
        }
        else if(u && desktopNotifications) {
            getFCMToken(u,getToken(),false,true);
            setDesktopNotifications(false);
            if(!mobileCheck()) {
                setShowUnblock(false);
            }
        }
        else if(u) { 
            getFCMToken(u,getToken(),true,true);
            setDesktopNotifications(true);
            if(!mobileCheck()) {
                setShowUnblock(false);
            } else {
                setShowDesktopFromMobile(true);
            }
        }
    }

    function handleAppOverride() {
        let u = getUser();
        if(mobileCheck() && Notification.permission==="denied") {
            setShowUnblock(true);
        }
        else if(u && appNotifications) {
            getFCMToken(u,getToken(),false);
            setAppNotifications(false);
            setAppNotificationsParent(false);
            if(mobileCheck()) {
                setShowUnblock(false);
            }
        } else if(u) {
            getFCMToken(u,getToken());
            setAppNotifications(true);
            setAppNotificationsParent(true);
            if(mobileCheck()) {
                setShowUnblock(false);
            } else {
                setShowMobileFromDesktop(true);
            }
        }
    }

    return (
        <section className="notifications-panel notifications-master">
            <h2 className="notifications-section-title">Master Controls</h2>
            <p className="notifications-section-note">
                These settings apply across all cameras and override individual power and motion notification preferences.
            </p>
            <div className="notifications-toggle-list">
                <div className="notifications-toggle-row">
                    <span className="notifications-toggle-label">Allow us to send you emails</span>
                    <FormGroup>
                        <Checkbox
                            checked={settings ? settings.email != null ? settings.email : false : false}
                            onChange={() => handleEmailOverride()}
                        >
                            <Glyphicon glyph="envelope" />
                        </Checkbox>
                    </FormGroup>
                </div>
                {'Notification' in window && (
                    <>
                        <div className="notifications-toggle-row">
                            <span className="notifications-toggle-label">Allow us to send you mobile app notifications</span>
                            <FormGroup>
                                <Checkbox checked={appNotifications} onChange={() => handleAppOverride()}>
                                    <Glyphicon glyph="phone" />
                                </Checkbox>
                            </FormGroup>
                        </div>
                        {showMobileFromDesktop && (
                            <p className="notifications-hint">You may need to unblock notifications on those devices.</p>
                        )}
                        <div className="notifications-toggle-row">
                            <span className="notifications-toggle-label">Allow us to send you desktop app notifications</span>
                            <FormGroup>
                                <Checkbox checked={desktopNotifications} onChange={() => handleDesktopOverride()}>
                                    <Glyphicon glyph="modal-window" />
                                </Checkbox>
                            </FormGroup>
                        </div>
                        {showDesktopFromMobile && (
                            <p className="notifications-hint">You may need to unblock notifications on those devices.</p>
                        )}
                        {showUnblock && (
                            <div className="notifications-callout">
                                {pwmApp ? (
                                    <>
                                        It looks like you've blocked notifications in your app.<br /><br />
                                        Open this app's settings and allow access to notifications, then return here and toggle the setting above.
                                    </>
                                ) : (
                                    <>
                                        It looks like you've blocked notifications in the browser.<br /><br />
                                        Click the button next to the address bar and allow this site to show notifications, then toggle the setting above again.
                                        <img src={Denied} alt="How to allow notifications in your browser" />
                                    </>
                                )}
                            </div>
                        )}
                    </>
                )}
            </div>
        </section>
    );
}
